export type CalendarView = "day" | "week" | "month";

interface CalendarToolbarProps {
  view: CalendarView;
  onViewChange: (view: CalendarView) => void;
  title: string;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  statusFilter: string;
  onStatusFilter: (value: string) => void;
}

const VIEWS: { key: CalendarView; label: string }[] = [
  { key: "day", label: "Day" },
  { key: "week", label: "Week" },
  { key: "month", label: "Month" },
];

const STATUS_FILTERS = [
  { value: "all", label: "All statuses" },
  { value: "new", label: "New" },
  { value: "confirmed", label: "Confirmed" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

export default function CalendarToolbar({
  view,
  onViewChange,
  title,
  onPrev,
  onNext,
  onToday,
  statusFilter,
  onStatusFilter,
}: CalendarToolbarProps) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 flex flex-col lg:flex-row lg:items-center gap-3">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onPrev}
          aria-label="Previous"
          className="w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <button
          type="button"
          onClick={onNext}
          aria-label="Next"
          className="w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>
        <button
          type="button"
          onClick={onToday}
          className="h-10 px-4 rounded-md border border-background-300 text-sm font-semibold text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          Today
        </button>
        <h2 className="font-heading text-lg md:text-xl text-foreground-950 font-semibold ml-2 whitespace-nowrap">
          {title}
        </h2>
      </div>

      <div className="lg:ml-auto flex items-center gap-2 flex-wrap">
        <select
          value={statusFilter}
          onChange={(event) => onStatusFilter(event.target.value)}
          className="bg-background-100 border border-background-300 rounded-md px-3 py-2.5 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer"
        >
          {STATUS_FILTERS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <div className="flex items-center gap-1 bg-background-100 border border-background-200 rounded-full p-1">
          {VIEWS.map((option) => (
            <button
              key={option.key}
              type="button"
              onClick={() => onViewChange(option.key)}
              className={`text-sm font-semibold px-4 py-1.5 rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                view === option.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-foreground-900"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}